module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAOVBMVEUAAABFgP9EgP9AgP9EgP9EgP9DgP9Egf9EgP9AgP9EgP9DgP9BgP9IgP9EgP9DgP9DgP9DgP9EgP8DguSMAAAAEnRSTlMA378Q70CgX4Agz28wIH+QUK/+qpAOAAAA8klEQVRYw+2W6wqDMAxGm15Se1E33/9hBxOZsTptJoPNnL/CIUm/BJUgCF/GJA2VaK9KHAwMIBeegYmjnha4ImuIyA9sGiKKfJEmooGPLURcfkfUhIzwdihNyGlflMY4xM1HSs/gpF3RlK+Ma8X0btrMA6KJ4GHZ0+vjrogG9Xaf9US2qtsfNrZqRkAgxYyY/tDzo6N7GHUiGqcP5wh8u3n/ulgXSFxVud7WJ7s4pOammSsC2M57sp/sGjoy4GoRHXzo4l+cERGJSESXEtmzRPqsX7+GL/JEZIDrAUXJzCnZoBYEVk0xqxKPuhJ0ShCEy/MAa6qm5A6jZzIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/email.png
// module id = maZZ
// module chunks = 1